import { Link, useLocation } from "react-router-dom";
import { Check, Phone } from "lucide-react";
import { formatLongDate } from "@/lib/format";
import { useSettings } from "@/context/SettingsContext";
import Seo from "@/components/site/Seo";

export default function Conferma() {
  const { state } = useLocation();
  const res = state?.reservation;
  const { settings } = useSettings();

  if (!res) {
    return (
      <div className="pt-40 pb-32 bg-cream">
        <div className="container-ed max-w-xl">
          <h1 className="font-serif text-4xl text-wood">Nessuna prenotazione da mostrare</h1>
          <p className="mt-5 text-sm text-foreground/65">
            Il riepilogo è disponibile subito dopo l'invio della richiesta. Se hai chiuso la pagina,
            controlla l'email di riepilogo oppure chiamaci.
          </p>
          <Link
            to="/prenota"
            className="mt-8 inline-flex px-8 py-4 bg-sage text-cream text-[0.7rem] uppercase tracking-[0.22em]"
          >
            Vai alla prenotazione
          </Link>
        </div>
      </div>
    );
  }

  const rows = [
    ["Riferimento", res.reference],
    ["Nome", `${res.first_name} ${res.last_name}`],
    ["Data", formatLongDate(res.date)],
    ["Orario", `${res.time} · ${res.service_name}`],
    ["Persone", `${res.guest_count}`],
    ["Telefono", res.phone],
    ["Email", res.email],
  ];
  if (res.notes) rows.push(["Note", res.notes]);

  return (
    <>
      <Seo title="Richiesta ricevuta · Osteria Aterrana" description="Riepilogo della richiesta di prenotazione." path="/prenotazione-confermata" />
      <div className="pt-36 md:pt-44 pb-28 bg-cream" data-testid="confirmation-page">
        <div className="container-ed max-w-3xl">
          <span className="inline-flex items-center justify-center h-11 w-11 border border-sage text-sage">
            <Check size={20} strokeWidth={1.4} />
          </span>
          <h1 className="mt-8 font-serif text-4xl sm:text-5xl leading-tight text-wood">
            Richiesta ricevuta, in attesa di conferma.
          </h1>
          <p className="mt-6 text-sm md:text-lg text-foreground/70 max-w-xl leading-relaxed">
            Grazie {res.first_name}. Ti abbiamo inviato un'email con il riepilogo: conserva il
            riferimento qui sotto. Confermiamo la disponibilità in sala e ti scriviamo appena
            possibile. Per qualsiasi cosa, basta una telefonata.
          </p>

          <dl className="mt-12 divide-y divide-wood/12 border-y border-wood/15" data-testid="confirmation-details">
            {rows.map(([k, v]) => (
              <div key={k} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-8 py-4">
                <dt className="eyebrow text-wood/50 sm:w-40 shrink-0">{k}</dt>
                <dd
                  className={`text-base ${k === "Riferimento" ? "font-serif text-2xl text-wood tracking-wide" : "text-foreground/80"}`}
                  data-testid={k === "Riferimento" ? "confirmation-reference" : undefined}
                >
                  {v}
                </dd>
              </div>
            ))}
          </dl>

          <div className="mt-12 flex flex-wrap gap-3">
            <a
              href={`tel:${settings.phone_link || "+393311091971"}`}
              className="inline-flex items-center gap-2 px-8 py-4 bg-wood text-cream text-[0.7rem] uppercase tracking-[0.2em] hover:bg-sage transition-colors duration-500"
            >
              <Phone size={14} /> Modifica per telefono
            </a>
            <Link
              to="/"
              className="inline-flex px-8 py-4 border border-wood/30 text-wood text-[0.7rem] uppercase tracking-[0.2em] hover:bg-wood hover:text-cream transition-colors duration-500"
            >
              Torna alla home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
